import moment from "../../plugins/moment";
import * as MUTATION_TYPES from "./mutation-types";
import * as STEPPER_MUTATIONS from "../stepper/mutation-types";
import * as GETTER_TYPES from "./getter-types";
import * as ACTION_TYPES from "./action-types";
import { SET_SNACKBAR } from "../snackbar/mutation-types";
import { GET_SNACKBAR } from "../snackbar/getter-types";
import { SHOW_ERROR_SNACKBAR } from "../snackbar/mutation-types";

const getInitialState = () => ({
  booking: {
    id: null,
    bookingToken: null,
    travellerPrice: null,
    loading: false,
    travellers: {
      adults: {
        total: 0,
        data: []
      },
      childs: {
        total: 0,
        data: []
      },
      babies: {
        total: 0,
        data: []
      }
    },
    outgoingFlight: {
      departure: null,
      arrival: null
    },
    returnFlight: {
      departure: null,
      arrival: null
    },
    airlines: [],
    extras: {
      included: [
        {
          avatar: {
            icon: "/img/icons/checkin-black.svg",
            size: 48
          },
          title: 'shared.check_in_included',
          copy: "shared.recive_cards_24"
        },
        {
          avatar: {
            icon: "/img/icons/bag.svg",
            size: 48
          },
          title: 'shared.handbag_included',
          copy:
            "shared.you_may_carry_a_bag"
        }
      ],
      available: []
    },
    accomodation: {
      options: [],
      selected: null
    },
    comments: "",
    discountCode: "",
    newsletter: false,
    payment: {
      type: null, // Credit card | Paypal
      card: null
    },
    terms: {
      promotions: {
        value: false,
        error: false
      },
      terms: {
        value: false,
        error: false
      }
    }
  },
  reservation: {
    loading: true,
    totalPrice: 0,
    adultsQuantity: 1,
    outboundTrip: {
      departure: {
        airport: "",
        datetime: ""
      },
      arrival: {
        airport: "",
        datetime: ""
      }
    },
    inboundTrip: {
      departure: {
        airport: "",
        datetime: ""
      },
      arrival: {
        airport: "",
        datetime: ""
      }
    },
    document_need: true
  },
  flexExtraSelected:0,
  flexExtras: []
});

export const bookingState = {
  ...getInitialState()
};

export const bookingGetters = {
  [GETTER_TYPES.GET_BOOKING](state) {
    return state.booking;
  },
  [GETTER_TYPES.GET_FLEX_EXTRAS](state) {
    return state.flexExtras;
  },
  [GETTER_TYPES.GET_FLEX_EXTRA_SELECTED](state) {
    return state.flexExtraSelected;
  },
  [GETTER_TYPES.GET_DOCUMENT_NEED](state){
    return state.document_need;
  },
  [GETTER_TYPES.GET_BOOKING_FLIGHT_PRICE](state, getters){
    return state.booking.travellerPrice *
    getters[GETTER_TYPES.GET_BOOKING_TRAVELLERS_TOTAL]
  },
  [GETTER_TYPES.GET_BOOKING_TOTAL_PRICE_WITHOUT_DISCOUNT](state, getters) {
    let extrasTotal = 0;
    state.booking.extras.available.forEach(extra => {
      if (extra.selected) {
        extrasTotal += getters[GETTER_TYPES.GET_AGGREGATE_EXTRA_PRICE](extra);
      }
    });

    let flexExtraTotal = 0;

    if(state.flexExtraSelected){
      flexExtraTotal = getters[GETTER_TYPES.GET_FLEX_EXTRA_SELECTED].price
    }

    return (
      state.booking.travellerPrice *
      getters[GETTER_TYPES.GET_BOOKING_TRAVELLERS_TOTAL] +
      extrasTotal +
      flexExtraTotal
    );
  },
  [GETTER_TYPES.GET_BOOKING_TOTAL_PRICE](state, getters) {
    const total =
      getters[GETTER_TYPES.GET_BOOKING_TOTAL_PRICE_WITHOUT_DISCOUNT];

    let discount = 0;

    if (getters[GETTER_TYPES.GET_BOOKING_DISCOUNT_CODE_IS_APPLICABLE]) {
      const { type, value_discount } = state.booking.discountCode;

      switch (type) {
        case "percent":
          discount = Number(((total / 100) * value_discount).toFixed(2));
          break;
        case "fixprice":
          discount = value_discount;
      }
    }

    return Number((total - discount).toFixed(2));
  },
  [GETTER_TYPES.GET_BOOKING_DATE](state) {
    return state.booking.outgoingFlight.departure.datetime?.format(
      "DD/MM/YYYY"
    );
  },
  [GETTER_TYPES.GET_BOOKING_TRAVELLERS_TOTAL](state) {
    return (
      parseInt(state.booking.travellers.adults.total) +
      parseInt(state.booking.travellers.childs.total) +
      parseInt(state.booking.travellers.babies.total)
    );
  },
  [GETTER_TYPES.GET_BOOKING_TRAVELLERS_MERGED](state) {
    let travellers = [];
    for (let i = 0; i < state.booking.travellers.adults.total; i++) {
      travellers.push("adult");
    }
    for (let i = 0; i < state.booking.travellers.childs.total; i++) {
      travellers.push("child");
    }
    for (let i = 0; i < state.booking.travellers.babies.total; i++) {
      travellers.push("baby");
    }
    return travellers;
  },
  [GETTER_TYPES.GET_BOOKING_DISCOUNT_CODE](state) {
    return state.booking.discountCode;
  },
  [GETTER_TYPES.GET_BOOKING_DISCOUNT_CODE_IS_APPLICABLE](state, getters) {
    if (!state.booking.discountCode) return false;

    switch (state.booking.discountCode.requirements) {
      case "monto":
        return (
          getters[GETTER_TYPES.GET_BOOKING_TOTAL_PRICE_WITHOUT_DISCOUNT] >=
          state.booking.discountCode.req_qty
        );
      case "none":
        return true;
    }
  },
  [GETTER_TYPES.GET_BOOKING_DISCOUNT](state, getters) {
    if (
      !state.booking.discountCode ||
      !getters[GETTER_TYPES.GET_BOOKING_DISCOUNT_CODE_IS_APPLICABLE]
    )
      return 0;

    const { type, value_discount } = state.booking.discountCode;

    switch (type) {
      case "percent":
        return Number(
          (
            (getters[GETTER_TYPES.GET_BOOKING_TOTAL_PRICE_WITHOUT_DISCOUNT] /
              100) *
            value_discount
          ).toFixed(2)
        );
      case "fixprice":
        return value_discount;
    }
  },
  [GETTER_TYPES.GET_RESERVATION](state) {
    return state.reservation;
  },
  [GETTER_TYPES.GET_TERMS](state) {
    return state.booking.terms;
  },
  [GETTER_TYPES.GET_BOOKING_DESTINATION_CITY_CODE](state) {
    if (!state.destinies.flights.length) return;
    let flights = state.destinies.flights;
    if (typeof state.destinies.flights[0][0] === "string") {
      // donde
      flights = state.destinies.flights.flatMap(([day, flights]) => flights);
    }
    const destination = flights.find(destination => {
      return [destination.airportTo, destination.cityCodeTo].includes(
        state.booking.outgoingFlight.arrival.code
      );
    });
    return destination && destination.cityCodeTo;
  },
  [GETTER_TYPES.GET_AGGREGATE_EXTRA_PRICE]: (state, getters) => extra => {
    const singlePrice = extra.price;
    const { onePerPassenger, hasCounter } = extra;
    let quantity;

    if (onePerPassenger) {
      quantity = getters[GETTER_TYPES.GET_BOOKING_TRAVELLERS_TOTAL];
    } else {
      quantity = hasCounter ? extra.quantity : 1;
    }

    return extra.price * quantity;
  },
};

export const bookingMutations = {
  setFlexExtraId(state, payload) {
    state.flexExtraId = payload
    console.log('setextraid',payload);
  },
  setFlexExtra(state, payload) {
    state.flexExtra = payload
    console.log('setextra',payload);
  },
  [MUTATION_TYPES.RESET_BOOKING_STATE](state) {
    const { booking, reservation } = getInitialState();
    state.booking = booking;
    state.reservation = reservation;
  },
  [MUTATION_TYPES.SET_DOCUMENT_NEED_MUTATION](state, payload){
    Vue.set(state, 'document_need', payload);
  },
  [MUTATION_TYPES.SET_BOOKING_LOADING](state, payload) {
    state.booking.loading = payload;
  },
  [MUTATION_TYPES.BOOKING_UPDATE](state, payload) {
    Object.assign(state.booking, payload);
  },
  [MUTATION_TYPES.SET_FLEX_EXTRAS](state, payload) {
    state.flexExtras = [...payload];
  },
  [MUTATION_TYPES.SET_FLEX_EXTRA_SELECTED](state, payload) {
    state.flexExtraSelected = payload;
  },
  [MUTATION_TYPES.FETCH_EXTRAS_SUCCESS](state, payload) {
    const availableExtras = [];
    payload.forEach(extra => {
      availableExtras.push({
        id: extra.id,
        slug: extra.slug,
        selected: false,
        slug: extra.slug,
        title: extra.pivot ? extra.pivot.title : extra.title,
        copy: extra.pivot ? extra.pivot.description : extra.description,
        price: extra.pivot ? extra.pivot.price : extra.price,
        hasCounter: extra.has_counter,
        onePerPassenger: extra.one_per_passenger,
        quantity: extra.has_counter ? 0 : 1
      });
    });
    state.booking.extras.available = availableExtras;
  },
  [MUTATION_TYPES.SELECT_BOOKING_EXTRA](state, payload) {
    const selectedExtra = state.booking.extras.available.find(
      extra => extra.id === payload
    );
    selectedExtra.selected = !selectedExtra.selected;
  },
  [MUTATION_TYPES.SET_BOOKING_EXTRA_QUANTITY](state, payload) {
    const selectedExtra = state.booking.extras.available.find(
      extra => extra.id === payload.id
    );
    selectedExtra.quantity = payload.value;
    selectedExtra.selected = payload.value > 0;
  },
  [MUTATION_TYPES.SET_BOOKING_PASSENGERS](state, payload) {
    const typesMap = {
      adults: "adult",
      childs: "child",
      babies: "baby"
    };
    for (let [key, value] of Object.entries(typesMap)) {
      state.booking.travellers[key].data = payload.filter(
        passenger => passenger.type === value
      );
    }
  },
  [MUTATION_TYPES.SET_BOOKING_DISCOUNT_CODE](state, payload) {
    state.booking.discountCode = payload;
  },
  [MUTATION_TYPES.SET_BOOKING_NEWSLETTER](state, payload) {
    state.booking.newsletter = payload;
  },
  [MUTATION_TYPES.SET_BOOKING_RESERVATION](state, payload) {
    state.reservation.payload = payload;
    state.reservation.totalPrice = payload.total_price;
    state.reservation.flightPrice = payload.flight_price_per_passenger * payload.passengers.length;
    state.reservation.adultsQuantity = payload.passengers.length;
    state.reservation.outboundTrip.departure.airport =
      payload.origin.name + " (" + payload.outbound_departure_airport + ")";
    state.reservation.outboundTrip.departure.datetime = moment(
      payload.outbound_departure_time
    );
    state.reservation.outboundTrip.arrival.airport =
      payload.destination.name + " (" + payload.outbound_arrival_airport + ")";
    state.reservation.outboundTrip.arrival.datetime = moment(
      payload.outbound_arrival_time
    );
    state.reservation.inboundTrip.departure.airport =
      payload.destination.name + " (" + payload.inbound_departure_airport + ")";
    state.reservation.inboundTrip.departure.datetime = moment(
      payload.inbound_departure_time
    );
    state.reservation.inboundTrip.arrival.airport =
      payload.origin.name + " (" + payload.inbound_arrival_airport + ")";
    state.reservation.inboundTrip.arrival.datetime = moment(
      payload.inbound_arrival_time
    );
    state.reservation.loading = false;
    state.reservation.destinationCode = payload.destination.code;
    state.reservation.code = payload.code;
    state.reservation.hotel = payload.accommodation;
    state.reservation.extras = payload.extras;
    state.reservation.destinationName = payload.destination.name;
    state.reservation.bags = payload.passengers.flatMap(p => p.bags);
    state.reservation.packContact = payload.pack_contact;

  },
  [MUTATION_TYPES.SET_TERMS](state, payload) {
    state.booking.terms = { ...payload };
  }
};

export const bookingActions = {

  [ACTION_TYPES.SET_BOOKING]({ commit, state }, payload) {
    commit(MUTATION_TYPES.BOOKING_UPDATE, payload);
  },
  [ACTION_TYPES.SET_DOCUMENT_NEED]({commit, state}, payload){
    const {adults,childs,babies,bookingToken} = payload;
    axios.get(`/api/check-flight?adults=${adults}&children=${childs}&infants=${babies}&booking_token=${bookingToken}`)
      .then(({data}) => commit(MUTATION_TYPES.SET_DOCUMENT_NEED_MUTATION, data.document_need))
      .catch(err => console.error(err));
  },
  [ACTION_TYPES.SET_BOOKING_LOADING]({ commit, state }, payload) {
    commit(MUTATION_TYPES.SET_BOOKING_LOADING, payload);
  },
  [ACTION_TYPES.RETREIVE_DATA_EXTRAS_STEP]({commit, dispatch}, priceFlight){
    commit(STEPPER_MUTATIONS.SET_STEPPER_LOADING, true);
    commit(MUTATION_TYPES.SET_BOOKING_LOADING, true);

    Promise.all([dispatch(ACTION_TYPES.FETCH_FLEX_EXTRAS, priceFlight), dispatch(ACTION_TYPES.FETCH_BOOKING_EXTRAS)])
    .catch(err => {
      commit(SHOW_ERROR_SNACKBAR, err)
    }).finally(() => {
      commit(STEPPER_MUTATIONS.SET_STEPPER_LOADING, false);
      commit(MUTATION_TYPES.SET_BOOKING_LOADING, false);
      commit(STEPPER_MUTATIONS.NEXT_STEP);
    })
  },
  async [ACTION_TYPES.FETCH_FLEX_EXTRAS]({commit}, priceFlight) {
    return axios
    .get(`/api/flex-extras?flightPrice=${priceFlight}`)
    .then(async ({data}) => {
      await commit(MUTATION_TYPES.SET_FLEX_EXTRAS, data);
      return Promise.resolve()
    })
    .catch(err => {
      return Promise.reject('Error getting Flex Extras')
    })
  },
  async [ACTION_TYPES.FETCH_BOOKING_EXTRAS]({ commit, state, getters }) {
    const destinationCityCode =
      getters[GETTER_TYPES.GET_BOOKING_DESTINATION_CITY_CODE] ||
      router.currentRoute.query.destino;
    return axios
      .get(`/api/extras?destination=${destinationCityCode}&providers=${state.booking.airlines}`)
      .then(({data}) => {
          commit(MUTATION_TYPES.FETCH_EXTRAS_SUCCESS, data);
          return Promise.resolve();
      })
      .catch(err => {
        return Promise.reject('fetching extras error')
      });
  },
  [ACTION_TYPES.SELECT_BOOKING_EXTRA]({ commit, state }, payload) {
    commit(MUTATION_TYPES.SELECT_BOOKING_EXTRA, payload);
  },
  [ACTION_TYPES.SET_BOOKING_EXTRA_QUANTITY]({ commit, state }, payload) {
    commit(MUTATION_TYPES.SET_BOOKING_EXTRA_QUANTITY, payload);
  },
  [ACTION_TYPES.SET_RESERVATION]({ commit, state }, payload) {
    commit(STEPPER_MUTATIONS.SET_STEPPER_LOADING, true);
    setTimeout(() => {
      commit(STEPPER_MUTATIONS.SET_STEPPER_LOADING, false);
      commit(STEPPER_MUTATIONS.NEXT_STEP);
    }, 500);
  },
  [ACTION_TYPES.SET_BOOKING_PASSENGERS]({ commit, state }, payload) {
    commit(MUTATION_TYPES.SET_BOOKING_PASSENGERS, payload);
  },
  [ACTION_TYPES.REDSYS_RETRIEVE_PARAMS]({ commit, state }, payload) {
    commit(STEPPER_MUTATIONS.SET_STEPPER_LOADING, true);
    axios
      .get("/api/redsys/retrieve-parameters", {
        params: {
          reservation: prepareReservation()
        }
      })
      .then(res => {
        this.params = res.data["params"];
        this.signature = res.data["signature"];
        this.version = res.data["version"];
      })
      .then(res => {
        //Submit redsys Form
        //Número de tarjeta: 4548812049400004
        //Caducidad: 12/20
        //Código CVV2: 123
        //Código CIP: 123456
        document.getElementById("redsysForm").submit();
      })
      .catch(err => {
        console.log(err);
        this.$toastr.e(
          window.i18n.t('toast.error_2')
        );
      });
  },
  [ACTION_TYPES.RETREIVE_RESERVATION]({ commit, state }, payload) {
    return axios
      .get(`/api/reservation/${payload}`)
      .then(data => {
        if (data.data.reservation) {
          console.log(data.data.reservation);
          commit(MUTATION_TYPES.SET_BOOKING_RESERVATION, data.data.reservation);
        }
        return data.data.reservation;
      })
      .catch(err => {
        console.log(err);
        store.commit(SET_SNACKBAR, {
          ...store.getters.GET_SNACKBAR,
          text: "No se ha completado la reserva. Inténtalo nuevamente",
          color: "error",
          value: true
        });
      });
  }
};
